import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { ADPResourceService as ResourceService } from 'digital-core';
import { PaymentMethodTypes } from '../models';

@Injectable()
export class PaymentService {
  constructor(private resourceService: ResourceService) {}

  getPaymentMethods(): Observable<PaymentMethodTypes[]> {
    let paymentMethods = [];

    // load iban number payment method setting from resources
    let ibanSetting = this.resourceService.getPortalSetting(
      "PaymentMethod_IBANNumber"
    );
    // check iban number setting
    if (ibanSetting && ibanSetting.Value === "true") {
      paymentMethods.push(PaymentMethodTypes.IBAN);
    }

    // load credit card payment method setting from resources
    let creditCardSetting = this.resourceService.getPortalSetting(
      "PaymentMethod_CreditCard"
    );
    // check credit card setting
    if (creditCardSetting && creditCardSetting.Value === "true") {
      paymentMethods.push(PaymentMethodTypes.CreditCard);
    }

    return of(paymentMethods);
  }
}
